import styled, { css } from 'styled-components'
import { FaStar, FaRegStar } from 'react-icons/fa'

type ContainerProps = {
  isActive: boolean
}

export const Container = styled.li<ContainerProps>`
  ${({ isActive, theme }) => css`
    align-items: center;
    background-color: ${isActive ? theme?.colors?.textColor : theme?.colors?.white};
    border: 1px solid ${({ theme }) => theme?.colors?.gray4};
    border-radius: 4px;
    color: ${isActive ? theme?.colors?.white : theme?.colors?.textColor};
    cursor: pointer;
    display: flex;
    font: normal normal 600 14px/23px Manrope, sans-serif;
    height: 38px;
    justify-content: space-around;
    margin: 0;
    padding: 0 5px;
    transition: all 0.2s ease;
    width: 41px;
  `}
`

const Icon = css`
  width: 12px;
  height: 11px;
  min-width: 12px;
  min-height: 11px;
`

export const StarIconFull = styled(FaStar)`
  ${Icon}
`

export const StarIconEmpty = styled(FaRegStar)`
  ${Icon}
`
